import { Box, Typography } from '@mui/material';
import { BRAND } from '../lib/brand';

// The wordmark in the sidebar and on the landing header: the brand's logo
// image when one is configured (BRAND_LOGO_URL), else its name as text.
export function BrandMark({ size = 18 }: { size?: number }) {
  if (BRAND.logoUrl) {
    return (
      <Box
        component="img"
        src={BRAND.logoUrl}
        alt={BRAND.name}
        sx={{ display: 'block', height: Math.round(size * 1.6), maxWidth: 200, objectFit: 'contain' }}
      />
    );
  }
  return (
    <Typography component="span" sx={{ display: 'block', fontSize: size, fontWeight: 800, letterSpacing: '-0.02em' }}>
      {BRAND.name}
    </Typography>
  );
}
